'use client';

import { usePromptTrigger } from '@/hooks/usePromptTrigger';

interface UnitPromptTriggerProps {
  unitId: string;
  /**
   * The URL to send the user to after a successful subscription
   * purchase — typically the building's report page. Passed through
   * to localStorage on CTA click so the success page can honour it.
   */
  reportReturnUrl: string;
}

/**
 * Fires the prompt-counter increment for a unit page view. Deduped by
 * unitId. Renders nothing.
 */
export function UnitPromptTrigger({ unitId, reportReturnUrl }: UnitPromptTriggerProps) {
  usePromptTrigger('unit', unitId, reportReturnUrl);
  return null;
}
